import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid';

import type { OptionsMap } from '@openx/types/options';
import type { JSX } from 'react';
import {
  StyledAllowedFiltersGrid,
  StyledAllowedIcon,
  StyledAllowTitleTypography,
  StyledFilterTitleTypography,
  StyledRemoveIconButton,
  StyledRemoveIconWrapperDiv,
} from './AllowedItems.styled';

type AllowedItemsProps = {
  'data-test': string;
  onRemove: (id: string) => void;
  selectedOptions: string[];
  title: string;
  options?: OptionsMap;
  readonly?: boolean;
};

export const AllowedItems = ({
  'data-test': dataTest,
  onRemove,
  selectedOptions,
  title,
  options,
  readonly,
}: AllowedItemsProps): JSX.Element => {
  return (
    <>
      <StyledAllowTitleTypography data-test={`${dataTest.toLocaleLowerCase().split(' ')[0]}-allow`} variant="overline">
        {title}
      </StyledAllowTitleTypography>
      {options && selectedOptions.length > 0 && (
        <Grid
          container
          wrap="nowrap"
          sx={{
            alignItems: 'flex-start',
          }}
        >
          <Grid>
            <StyledAllowedIcon fontSize="small" />
          </Grid>

          <Grid
            container
            sx={{
              width: 'fit-content',
            }}
          >
            {selectedOptions.map((filterId, index) => {
              return (
                <StyledAllowedFiltersGrid container wrap="nowrap" key={filterId} sx={{ alignItems: 'center' }}>
                  <StyledFilterTitleTypography
                    data-test={`${dataTest.toLocaleLowerCase().split(' ')[0]}-item`}
                    variant="body1"
                  >
                    {options[filterId]?.name || filterId}
                    {index < selectedOptions.length - 1 ? ',' : ''}
                  </StyledFilterTitleTypography>

                  {!readonly && (
                    <StyledRemoveIconWrapperDiv className="removeIconWrapper">
                      <StyledRemoveIconButton onClick={() => onRemove(filterId)} size="large">
                        <CloseIcon data-test="close-dialog" fontSize="small" />
                      </StyledRemoveIconButton>
                    </StyledRemoveIconWrapperDiv>
                  )}
                </StyledAllowedFiltersGrid>
              );
            })}
          </Grid>
        </Grid>
      )}
    </>
  );
};
